import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';
import Image from '@nubank/nuds-web/components/Image/Image';
import Link from '@nubank/nuds-web/components/Link/Link';

const StyledTypography = styled(Typography)`
  background: linear-gradient(87deg, #9F2DEB 0%, #6200A3 100%);
  /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  height: 100%;
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`;

const StyledImage = styled(Image)`
  width: 248px;
  height: 200px;
  margin: 0 auto;
  object-fit: cover;
  object-position: center;
  border-radius: 12px;
`;

const StyledBox = styled(Box)`
  :last-child, :nth-child(4), :nth-child(8) {
    margin-right: 0; /* Exclude margin from the last grid item */
  }

  cursor: pointer;
`;

const StyledFlexBox = styled(Box)`
  column-gap: 14px;
`;

const StyledCategoryTitle = styled(Typography)`
  font-size: 30px;
  line-height: 120%; /* 36px */
  letter-spacing: -0.9px;
`;

const calculateWidth = length => {
  if (length < 10) {
    return '120px';
  }
  if (length < 20) {
    return '180px';
  }
  return '100%';
};

export default function Categories() {
  const { formatMessage } = React.useContext(NuDsContext);
  const categories = formatMessage({ id: 'cms.categories' });

  return (
    <Box
      tag="section"
      id="categorias"
      paddingTop={{ xs: '24px', lg: '48px' }}
      width="100vw"
      background={{ xs: 'linear-gradient(to bottom, white 0%, white 10%, #F8F8FA 10%, #F8F8FA 100%);', lg: 'linear-gradient(to bottom, white 0%, white 25%, #F8F8FA 25%, #F8F8FA 100%);' }}
    >
      <Box
        display="flex"
        flexDirection={{ xs: 'column', lg: 'row' }}
        alignItems="center"
        justifyContent="center"
        marginBottom={{ xs: '78px', lg: '70px' }}
      >
        <Typography variant="heading2" marginRight="8px">
          Preguntas por
        </Typography>
        <StyledTypography variant="heading2" color="primary">
          Categoría
        </StyledTypography>
      </Box>

      {/* CATEOGORIES LIST */}

      <StyledFlexBox
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        margin="0 auto"
        paddingBottom="100px"
        maxWidth="1300px"
      >
        {
          categories.map(category => (
            <StyledBox
              key={category.id}
              width="300px"
              height="420px"
              backgroundColor="white.default"
              marginBottom="14px"
              paddingHorizontal="26px"
              paddingTop="26px"
              paddingBottom="30px"
              borderRadius="12px"
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="space-between"
              onClick={() => {
                window.location.href = `/ayuda/${category.slug}`;
              }}
            >
              <StyledImage
                src={category.image.url}
                alt={`Imagen de la categoria ${category.name}`}
                width="100%"
                height="100%"
                webp
              />

              <Box
                width={calculateWidth(category.name.length)}
                whiteSpace="nowrap"
                paddingVertical={{ xs: '8px', md: '24px' }}
              >
                <StyledCategoryTitle
                  variant="heading3"
                  textAlign="center"
                  strong
                  whiteSpace="normal"
                >
                  {category.name}
                </StyledCategoryTitle>
              </Box>

              <StyledLink
                href={`/ayuda/${category.slug}`}
                iconProps={{
                  name: 'arrow-right',
                }}
                target="_self"
              >
                Ver más preguntas
              </StyledLink>
            </StyledBox>
          ))
        }
      </StyledFlexBox>
    </Box>
  );
}
